import { pnlResponseMapper } from "@domains/mapper/Reports/PNLMappter";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class PNLReportRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getPNLReportData(requestData) {
        const accountCode = await this.accountDetails.getAccountCode();
        let url;
        if ((requestData === null || requestData === void 0 ? void 0 : requestData.accountIds) && (requestData === null || requestData === void 0 ? void 0 : requestData.accountIds) !== accountCode) {
            url = new URL(urlConfig.familyTagging + "/pnl");
            url.searchParams.append("accountIds", requestData.accountIds);
        }
        else {
            url = new URL(urlConfig.pnlReportUrl);
            url.searchParams.append("accountId", accountCode);
        }
        url.searchParams.append("fromDate", requestData.fromDate);
        url.searchParams.append("toDate", requestData.toDate);
        url.searchParams.append("duration", requestData.duration);
        if (requestData.assetType)
            url.searchParams.append("assetType", typeof requestData.assetType === "object"
                ? requestData.assetType.join(",")
                : requestData.assetType);
        let pnLReportData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            signal: requestData.abortSignal,
            avoidAuthToken: getIsInIFrame(),
        });
        return pnlResponseMapper(pnLReportData.data);
    }
}
export default PNLReportRepository;
